export type ScannerPayloadPredicate = (value: string) => boolean;

export interface ScannerPayloadResolution {
  raw: string;
  candidate: string | null;
  transformations: string[];
}

const BOUNDARY_CONTROL_CHARACTERS = new RegExp(
  String.raw`^[\u0000-\u001f\u007f]+|[\u0000-\u001f\u007f]+$`,
  "g"
);
const TEXTUAL_CONTROL_BOUNDARY =
  /^(?:\[(?:NUL|STX|ETX|EOT|CR|LF|TAB|HT)\]|<(?:NUL|STX|ETX|EOT|CR|LF|TAB|HT)>)+|(?:\[(?:NUL|STX|ETX|EOT|CR|LF|TAB|HT)\]|<(?:NUL|STX|ETX|EOT|CR|LF|TAB|HT)>)+$/gi;
const AIM_SYMBOLOGY_IDENTIFIER = /^\][A-Za-z][A-Za-z0-9]/;
const ALTERNATE_DELIMITER = /[:\t]/g;

const transformValue = (
  value: string,
  expression: RegExp,
  replacement: string,
  name: string,
  transformations: string[]
) => {
  const transformed = value.replace(expression, replacement);
  if (transformed !== value) transformations.push(name);
  return transformed;
};

const removeTransportWrappers = (raw: string, transformations: string[]) => {
  let value = raw.trim();
  if (value !== raw) transformations.push("trimmed-whitespace");
  value = transformValue(
    value,
    BOUNDARY_CONTROL_CHARACTERS,
    "",
    "removed-control-wrapper",
    transformations
  );
  value = transformValue(
    value,
    TEXTUAL_CONTROL_BOUNDARY,
    "",
    "removed-textual-control-wrapper",
    transformations
  );
  return transformValue(
    value,
    AIM_SYMBOLOGY_IDENTIFIER,
    "",
    "removed-aim-symbology-identifier",
    transformations
  );
};

export const resolveScannerPayload = (
  raw: string,
  predicate: ScannerPayloadPredicate
): ScannerPayloadResolution => {
  const transformations: string[] = [];
  const unwrapped = removeTransportWrappers(raw, transformations);
  if (predicate(unwrapped)) {
    return { raw, candidate: unwrapped, transformations };
  }

  const canonical = transformValue(
    unwrapped,
    ALTERNATE_DELIMITER,
    ";",
    "normalized-alternate-delimiter",
    transformations
  );
  return {
    raw,
    candidate: predicate(canonical) ? canonical : null,
    transformations,
  };
};
